/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Delete_Loading_DescInputs */

const es_feedback_delete_loading_desc = /** @type {(inputs: Feedback_Delete_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos procesando la eliminación. Esto tomará solo un momento.`)
};

const en_feedback_delete_loading_desc = /** @type {(inputs: Feedback_Delete_Loading_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We are processing the deletion. This will only take a moment.`)
};

/**
* | output |
* | --- |
* | "We are processing the deletion. This will only take a moment." |
*
* @param {Feedback_Delete_Loading_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_delete_loading_desc = /** @type {((inputs?: Feedback_Delete_Loading_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Delete_Loading_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_delete_loading_desc(inputs)
	return en_feedback_delete_loading_desc(inputs)
});
export { feedback_delete_loading_desc as "feedback.delete.loading_desc" }